import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWrite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.798 9.13.75 14.37l5.238-1.048 8.074-8.074c.41-.409.41-1.072 0-1.481l-2.709-2.71a1.05 1.05 0 0 0-1.481 0z"
    />
  </svg>
);
export default SvgWrite;
